// Maison Blanc Theme JS
document.addEventListener('DOMContentLoaded', function() {
  // Accordion on product page
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const item = this.closest('.accordion-item');
      item.classList.toggle('active');
    });
  });
  // Size selector on product page
  document.querySelectorAll('.size-option').forEach(function(option) {
    option.addEventListener('click', function() {
      this.closest('.size-options').querySelectorAll('.size-option').forEach(function(o) {
        o.classList.remove('selected');
      });
      this.classList.add('selected');
      var value = this.getAttribute('data-value');
      var select = document.querySelector('select[name="id"]');
      if (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].text.indexOf(value) !== -1) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    });
  });
});
